import { ApiService } from 'react-angle-dashboard-components'

type GetProceduresType = {
  query?: string
  page_number?: number
  page_limit?: number
  ordering?: string
}

export type CTPProcedure = {
  id: string
  procedure_code: string
  description: string
  auth_required: boolean
  age_restricted: boolean
  gender_restricted: boolean
  from_age: string
  thru_age: string
  gender: string
  effective_date: string
  term_date: string
}

export class CPTService extends ApiService {
  async getProcedures(params?: GetProceduresType): Promise<{
    procedures: CTPProcedure[]
    total_count: number
  }> {
    return this.request({
      method: 'get',
      url: '/procedures',
      params
    })
  }
}
